import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

import { renderInstructorPage } from './-route-wrappers';

const Roster = lazyRouteComponent(() => import('@/_instructor/roster'));

export const Route = createFileRoute('/_instructor/roster/$id')({
  component: () => renderInstructorPage(Roster),
});
